import React, { Component, Fragment } from "react";
import { Route, Switch } from "react-router";
import HomePage from "../pages/HomePage";
import AboutPage from "../pages/AboutPage";
import URLPage from "../pages/Master/URLPage";
import TravelCircuitPage from "../pages/Master/TravelCircuitPage";
import SpecialistPage from "../pages/Master/SpecialistPage";
import SearchLeadPage from "../pages/Transaction/SearchLeadPage";
import LoginPage from "../pages/Access/LoginPage";
import RegisterPage from "../pages/Access/RegisterPage";
import ForgotPasswordPage from "../pages/Access/ForgotPasswordPage";
import ProtectedRoute from "../pages/ProtectedRoutes";
import ManageBookingPage from "../pages/Transaction/ManageBookingPage";
import BookingListPage from "../pages/Transaction/BookingListPage";
import VendorPaymentPage from "../pages/Transaction/VendorPaymentPage";
import VendorPage from "../pages/Master/VendorPage";
import LocationPage from "../pages/Master/LocationPage";
import RoomCategoryPage from "../pages/Master/RoomCategoryPage";
import AdditionalChargePage from "../pages/Master/AdditionalChargePage";
import TestPage from "../pages/Master/TestPage";
import SpotBookingPage from "../pages/Transaction/SpotBookingPage";
import ReportPage from "../pages/Report/ReportPage";

class AppRoute extends Component {
  render() {
    return (
      <Fragment>
        <Switch>
          {/* <Route
            exact
            path="/"
            render={props => <HomePage {...props} key={Date.now()} />}
          /> */}
          <ProtectedRoute
            exact
            path="/"
            component={HomePage}
          />
          <ProtectedRoute
            exact
            path="/home"
            component={HomePage}
          />
          <Route
            exact
            path="/about"
            render={props => <AboutPage {...props} key={Date.now()} />}
          />
          <ProtectedRoute
            exact
            path="/url"
            component={URLPage}
          />
          <ProtectedRoute
            exact
            path="/tc"
            component={TravelCircuitPage}
          />
          <ProtectedRoute
            exact
            path="/loc"
            component={LocationPage}
          />
          <ProtectedRoute
            exact
            path="/spl"
            component={SpecialistPage}
          />
          <ProtectedRoute
            exact
            path="/vendor"
            component={VendorPage}
          />
          <ProtectedRoute
            exact
            path="/rc"
            component={RoomCategoryPage}
          />
          <ProtectedRoute
            exact
            path="/ac"
            component={AdditionalChargePage}
          />
          <ProtectedRoute
            exact
            path="/test"
            component={TestPage}
          />
          <ProtectedRoute
            exact
            path="/sl"
            component={SearchLeadPage}
          />
          <ProtectedRoute
            exact
            path="/bk-list"
            component={BookingListPage}
          />          
          <ProtectedRoute
            exact
            path="/bk/:bkId"
            render={(props) => <ManageBookingPage {...props} key={Date.now()} />}            
          />
          <ProtectedRoute
            exact
            path="/spot-bk/:bkId"
            render={(props) => <SpotBookingPage {...props} key={Date.now()} />}            
          />
          <ProtectedRoute
            exact
            path="/vendor-pay"
            render={(props) => <VendorPaymentPage {...props} key={Date.now()} />}            
          />
          <ProtectedRoute
            exact
            path="/rpt-list"
            render={(props) => <ReportPage {...props} key={Date.now()} />}            
          />
          <Route
            exact
            path="/login"
            render={props => <LoginPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/register"
            render={props => <RegisterPage {...props} key={Date.now()} />}
          />
          <Route
            exact
            path="/forgotpwd"
            render={props => <ForgotPasswordPage {...props} key={Date.now()} />}
          />
          {/* <ProtectedRoute
            exact
            path="/provider-profile"
            component={ProviderProfilePage}
          /> */}

        </Switch>
      </Fragment>
    );
  }
}

export default AppRoute;
